module.exports = __webpack_public_path__ + "img/add_row_before.97b1ce15.svg";